import asyncActionTypes from '../actions/types.js';

const initialState = {};

const openModalSignUp = (state = initialState, action) => {
  if (action.type === asyncActionTypes.OPEN_MODAL_SIGNUP.SUCCESS) {
    return {
      ...state,
      sourceOpenModalSignUp: action.payload,
    };
  } else {
    return state;
  }
};

const modalSignUpMethod = (state = initialState, action) => {
  if (action.type === asyncActionTypes.OPEN_MODAL_SIGNUP_METHOD.SUCCESS) {
    return {
      ...state,
      signUpMethod: action.payload,
    };
  } else {
    return state;
  }
};

export { openModalSignUp, modalSignUpMethod };